import { Controller } from "@hotwired/stimulus";
import { DirectUpload } from "@rails/activestorage";
import { Dropzone } from "dropzone";

export default class extends Controller {
  static targets = ["form", "fileInput", "blobIdInput", "dropZone"];

  connect() {
    Dropzone.autoDiscover = false;

    this.dropzone = new Dropzone(this.dropZoneTarget, {
      url: this.fileInputTarget.dataset.directUploadUrl,
      autoProcessQueue: false,
      autoQueue: false,
      disablePreviews: true,
      acceptedFiles:
        "image/*,application/pdf,text/csv,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation",
      maxFiles: this.fileInputTarget.multiple ? null : 1,
    });
    this.dropzone.on("addedfile", (file) => {
      this.uploadFile(file);
    });

    this.formTarget.addEventListener("turbo:submit-end", this.submitEnded);
  }

  disconnect() {
    this.formTarget.removeEventListener("turbo:submit-end", this.submitEnded);

    if (this.dropzone) {
      this.dropzone.destroy();
    }
  }

  uploadFile(file) {
    const fileInput = this.fileInputTarget;
    const url = fileInput.dataset.directUploadUrl;
    const upload = new DirectUpload(file, url);

    this.fileName = file.name;
    this.showStatus("Uploading", file.name);

    upload.create((error, blob) => {
      if (error) {
        this.fail("Failed to upload");
      } else {
        this.blobIdInputTarget.setAttribute("value", blob.signed_id);
        this.formTarget.requestSubmit();
      }
    });
  }

  // A successful attach replaces this field, so only a failure is left to show.
  submitEnded = (event) => {
    if (event.detail.success) return;

    this.fail("Failed to save");
  };

  fail(lead) {
    this.dropzone.removeAllFiles(true);
    this.showStatus(lead, `${this.fileName}. Try again.`, { error: true });
  }

  showStatus(lead, detail, { error = false } = {}) {
    this.dropZoneTarget.classList.toggle("bg-yellow-50", !error);
    this.dropZoneTarget.classList.toggle("animate-pulse", !error);

    // Dropzone opens the file picker only for a click on the drop zone itself,
    // so the status lets clicks through to it.
    const status = document.createElement("div");
    status.className = error
      ? "pointer-events-none text-danger text-center"
      : "pointer-events-none";

    const strong = document.createElement("strong");
    strong.textContent = lead;
    status.append(strong, ` ${detail}`);

    this.dropZoneTarget.replaceChildren(status);
  }
}
